import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";


export const useListaUprawnienOperatorow = (enabled = true) => {
    return useQuery({
        queryKey: [`oper_raporty`],
        queryFn: () => getList(`/oper/uzytkownicy/uprawnienia`),
        enabled: enabled,
    })
}